export default __webpack_public_path__ + "static/media/apalancamientoIcon.53c3d6de.svg";